/**
 * SendGrid list and group definitions for the Off-by-none admin app.
 * These are hardcoded SendGrid IDs that won't change.
 */

export const SENDGRID_LISTS = [
  { id: 'bed4cf37-f757-4669-a52e-3c060dc0d25c', name: 'Off-by-none', asmGroupId: 18439 },
  { id: '72fab869-f875-4e3e-be0b-540939bbaf42', name: 'Cloud Quiz', asmGroupId: 23905 },
];

/**
 * Map of list ID → display name for quick lookups.
 */
export const SENDGRID_LIST_NAMES = Object.fromEntries(
  SENDGRID_LISTS.map((l) => [l.id, l.name])
);

/**
 * Map of ASM group ID → display name for quick lookups.
 */
export const SENDGRID_GROUP_NAMES = Object.fromEntries(
  SENDGRID_LISTS.map((l) => [l.asmGroupId, l.name])
);
